import React, { HTMLAttributes } from 'react'
import './index.scss'
import clsx from 'clsx'
import { Screen } from '../Screen'
import { Card } from '../Card'

export function Spinner({
	className,
	...rest
}: HTMLAttributes<HTMLSpanElement>) {
	return <span className={clsx('spinner')} {...rest} />
}

interface SpinnerScreenProps {
	message?: string | React.ReactNode
}

export function SpinnerCard({ message }: SpinnerScreenProps) {
	return (
		<Card transperentBackground>
			<Card.Content className="spinner-container">
				<Spinner />
				{message === undefined ? null : typeof message === 'string' ? (
					<div className="spinner-message">{message}</div>
				) : (
					message
				)}
			</Card.Content>
		</Card>
	)
}

export function SpinnerScreen({ message }: SpinnerScreenProps) {
	return (
		<Screen>
			<SpinnerCard message={message} />
		</Screen>
	)
}
